import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { EmailValidator } from 'src/app/template/customValidators/emailValidator';

@Component({
  selector: 'app-gip-user-reset-pwd',
  templateUrl: './gipUserResetPwd.component.html',
  styleUrls: ['./gipUserResetPwd.component.css']
})
export class GipUserResetPwdComponent implements OnInit {

  constructor(private shareData: SharingDataService) { }
  modelInput = new FormGroup({
    USERGUID: new FormControl(),
    SALUTATIONS: new FormControl(),
    NAME: new FormControl('', Validators.maxLength(100)),
    SURNAME: new FormControl('', Validators.maxLength(100)),
    LOGIN: new FormControl('', Validators.maxLength(50)),
    EMAIL: new FormControl('', [EmailValidator, Validators.maxLength(250)]),

  });


  formular = [
    { formControlName: "USERGUID", required: true, textArea: true },
    { formControlName: "SALUTATIONS", required: true, picklist: "V_MS_SALUTATION_VL_T"},
    { formControlName: "NAME", required: true, textArea: true },
    { formControlName: "SURNAME", required: true, textArea: true },
    { formControlName: "LOGIN", required: true, textArea: true },
    { formControlName: "EMAIL", required: true, textArea: true },
  ];
resourceDefinition;

  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe((data)=> this.resourceDefinition = data);
  }

}
